import { defineInlineEdit } from "../../../../../components/MobileList/inlineEdit";

/**
 * views/management/posFields/form PUTs `{name, note}`, but there is no `note`
 * input and the slice's setById never populates one — so the dialog has always
 * sent `note: undefined`, which axios drops. Sending `name` alone matches it.
 */
export default defineInlineEdit({
  api: "posField",
  permission: "pos_field_edit",
  hydrate: false,
  toPayload: (source) => ({ name: source.name ?? "" }),
  fields: {
    name: { label: "الاسم", type: "text", required: true },
  },
});
